import {createStyles} from '@material-ui/core/styles';
import {disabledColor, lightGrayColor} from '../../styles/style';

const styles = createStyles({
  fields__tableHead: {
    backgroundColor: lightGrayColor,
  },
  fields__disabledText: {
    color: disabledColor,
    padding: '5px',
  },
  fields__enabledText: {
    padding: '5px',
  },
});

export default styles;
